import React from 'react';
import PropTypes from 'prop-types';
import useAuth from 'src/hooks/useAuth';
import LoadingScreen from 'src/components/LoadingScreen';

// ----------------------------------------------------------------------

AuthProtectFileConverter.propTypes = {
  children: PropTypes.node
};

const home_url = process.env.REACT_APP_DOMAIN;

function AuthProtectFileConverter({ children }) {
  const { isLoading, isAuthenticated, user } = useAuth();

  let generalAccessList = user.general_access_list;

  console.log('AuthProtect');
  console.log(user);

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated || !generalAccessList.includes('fileConverter')) {
    window.location = `${home_url}/unauthorized`;
    return <LoadingScreen />;
  }

  return <>{children}</>;
}

export default AuthProtectFileConverter;
